<template>
  <div class="site-footer">
    <div class="site-footer-info">
      <div class="site-link-info">
        <ul class="site-link-list">
          <li class="site-link-title">友情链接Link</li>
          <li><a href="https://yunguowang.weihengag.com/" target="_blank">云果网</a></li>
          <li><a href="http://oc.gaoyuanyunguo.com/" target="_blank">数字云果馆</a></li>
          <li><a href="https://www.weihengag.com/" target="_blank">农小蜂</a></li>
        </ul>
      </div>
      <div class="site-contact-info">
        <ul class="site-contact-list">
          <li><span class="site-contact-title">电话TEL：</span><span class="site-contact-text">13888214433、13468702971</span></li>
          <li><span class="site-contact-title">邮编POSTAL：</span><span class="site-contact-text">665800</span></li>
          <li><span class="site-contact-title">地址ADD：</span><span class="site-contact-text">孟连ㆍ朗勒 中国孟连牛油果集配中心</span></li>
        </ul>
      </div>
      <div class="site-qr-info" style="margin-left: 5%;">
<!--        <div class="site-qr-split"></div>-->
        <div class="site-qr-img"><img src="./../assets/group_qr_code1.png"></div>
        <div class="site-qr-text">
          <div>微信公众号</div>
          <div>扫一扫关注我们</div>
        </div>
      </div>
      <div class="site-qr-info">
        <div class="site-qr-split"></div>
        <div class="site-qr-img"><img src="./../assets/group_qr_code2.png"></div>
        <div class="site-qr-text">
            <div>客服中心</div>
            <div>扫一扫添加客服</div>
        </div>
      </div>

<!--      <div class="site-qr-info">-->
<!--        <div class="site-qr-split"></div>-->
<!--        <div class="site-qr-img"><img src="./../assets/group_qr_code3.png"></div>-->
<!--        <div class="site-qr-text">-->
<!--            <div>云上果园app</div>-->
<!--            <div>扫一扫</div>-->
<!--            <div>下载app</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="site-footer-copyright">
      <span><a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff;">滇ICP备18000824号-23</a></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FootTest',
  data () {
    return {
      msg: '网站备案信息 滇ICP备17009407号-1'
    }
  }
}
</script>
<style>
  .site-footer {
    height:280px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    text-align: center;
    color: #2c3e50;
    background:#f5f5f5;
  }
  .site-footer-info {
    margin: 0 auto;
    padding: 0px 0px 10px 0px;
    width: 1024px;
    height: 240px;
    //background-color: #eee;

  }
  .site-link-info {
    width:100%;
    height:50px;
    padding:10px 0px 15px 0px;
    text-align:left;
    border-bottom:1px solid #bbbbbb;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .site-link-list{
    width: 500px;
    height: 40px;
  }

  .site-link-list li{
    list-style: none;
    float: left;
    padding: 0px 15px 0px 15px;
    line-height: 40px;

  }

  .site-link-list li a{
    text-decoration: none;
    background: none;
    color:#335116!important;
    display: inline-block;
    height: auto;
  }

  .site-link-list li a:hover{
    color:#bbbbbb!important;
  }

  .site-link-title{
    padding:0px 10px 0px 0px!important;
    font-weight:600;
    color:#335116;
  }

  .site-contact-info {
    float:left;
    width:28%;
    height:170px;
    //background-color: #eee;
  }

  .site-contact-list{
    padding:10px 10px 10px 0px;
    font-size: 16px;
    line-height: 40px;
  }

  .site-contact-list li{
    list-style: none;
    text-align:left;
    display: flex;
  }

  .site-contact-title{
    font-weight:600;
    color:#335116;
  }
  .site-contact-text{
    color:#335116;
  }

  .site-qr-info {
    float:left;
    width:24%;
    height:170px;
    padding:30px 0px 30px 0px;
    //background-color: #eee;
  }
  .site-qr-split{
    float:left;
    width:1px;
    height:80px;
    margin-top:8px;
    background:#bbb;
  }

  .site-qr-img{
    float:left;
    width:110px;
    height:100px;
    padding-left:15px;
  }
  .site-qr-img img{
    height:80px;
  }
  .site-qr-text{
    float:left;
    width:120px;
    height:100px;
    padding:10px 5px 10px 15px;
    text-align:left;
    font-size:14px;
    line-height:24px;
  }

  .site-footer-copyright {
    margin: 0 auto;
    background-color:rgb(51,81,22);
    font-size:12px;
    color:#fff;
    padding: 10px 0;
    box-sizing: border-box;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .site-footer-copyright span::before{
    content:'copyright@ '
  }
</style>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue